import Types from '../types';

export default () => ({
  type: Types.RESET_ERRORS,
});
